import React from 'react';
import {ButtonBase, Tooltip, Typography} from '@material-ui/core';

const PanelChangeScopeBadge = ({classes, scope, interactive = false, expanded = false, onToggle}) => {
  if (!interactive) {
    return (
      <Typography variant="caption" component="span" className={classes.scopeBadge}>
        {scope}
      </Typography>
    );
  }

  const tooltipTitle = expanded
    ? 'Hide affected ad units'
    : 'Show affected ad units';

  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <ButtonBase
        className={classes.scopeBadgeButton}
        onClick={onToggle}
        aria-expanded={expanded}
        aria-label={tooltipTitle}
      >
        <Typography
          variant="caption"
          component="span"
          className={`${classes.scopeBadge} ${classes.scopeBadgeInteractive} ${
            expanded ? classes.scopeBadgeExpanded : ''
          }`}
        >
          {scope}
        </Typography>
      </ButtonBase>
    </Tooltip>
  );
};

export default React.memo(PanelChangeScopeBadge);
